import { GET_EVENTS_PAGE_ID } from 'constants/api'
import axios from 'axios'

const getEventById = async (id: string) => {
  try {
    const response = await axios.get(`${GET_EVENTS_PAGE_ID.replace('{eventId}', id)}`, {
      headers: { 'Ph-Api-Id': PH_API_ID ?? 1 }
    })

    return response.data
  } catch (error) {
    console.error('Error fetching event by ID:', error)
    return null
  }
}

export default getEventById
